import {getField, updateField} from "vuex-map-fields";
import InstaplayAPI from '../../../../services/api/instaplays'
import {getShareState} from "@/store/States";

const state = getShareState()

const getters = {
    getShareField(state) {
        return getField(state.form);
    },
}

const actions = {
    async getEmailGroups({commit, rootState}) {
        commit('instaplayForm/itemLoading', null, {root: true})

        let response
        try {
            response = await InstaplayAPI.getEmailGroups(rootState.auth.user.token)
        } catch (e) {
            return commit('instaplayForm/itemError', null, {root: true})
        }

        if (response.Success) {
            commit('addGroup', response.tournament)
            commit('instaplayForm/itemSuccess', null, {root: true})
        } else {
            commit('instaplayForm/itemError', null, {root: true})
        }
    }
}

const mutations = {
    resetState(state) {
        Object.assign(state, getShareState())
    },
    setForm(state, form) {
        state.form.privacy = form.privacy
        if (form.inviteEmail) {
            let group = {
                name: form.inviteEmail.name,
                addresses: form.inviteEmail.addresses
            }
            state.form.group = group
        }
    },
    addGroup(state, groups) {
        let groupsModel = []
        for (let group of groups)
            groupsModel.push({text: group.name, value: {name: group.name, addresses: group.addresses}})
        state.form.groups = groupsModel
    },
    updateShareField(state, field) {
        updateField(state.form, field);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
